import * as getter from '../types/getters'
import * as action from '../types/actions'
import Pattern from '../../models/Pattern'
import linq from 'linq'
import { classValidate } from '../../utility/validateUtility'
import { filterAndDestroy } from '../../utility/objectUtility'
import Form from 'vform'

function defaultColors() {
    return {
        patterns: [], //Array<Pattern>
    }
}

export const state = {
    patterns: defaultColors(),
}

export const mutations = {
    [action.FETCH_PATTERNS](state, patterns) {
        state.patterns = patterns
    },

    [action.ADD_PATTERN](state, pattern) {
        state.patterns.patterns.push(pattern)
    },

    [action.DELETE_PATTERN](state, pattern) {
        filterAndDestroy(state.patterns.patterns, (x) => x.id === pattern.id)
    },
}

export const actions = {
    async [action.FETCH_PATTERNS]({ commit }) {
        //@return {patterns: [Pattern]}
        const { data } = await axios.get('/api/patterns')

        const d = linq
            .from(data)
            .select((x) => {
                if (x.key === 'patterns') {
                    return {
                        key: x.key,
                        value: linq
                            .from(x.value)
                            .select((x) => new Pattern(x))
                            .toArray(),
                    }
                }
            })
            .toObject('$.key', '$.value')

        commit(action.FETCH_PATTERNS, d)
    },

    async [action.UPDATE_PATTERN]({ commit, state }, { model: pattern, form: form }) {
        classValidate(pattern, 'Pattern')

        await form.patch(`/api/pattern`)
    },

    async [action.DELETE_PATTERN]({ commit, state }, { model: pattern, form: form }) {
        classValidate(pattern, 'Pattern')

        await form.delete(`/api/pattern`)

        commit(action.DELETE_PATTERN, pattern)
    },

    async [action.DETACH_PATTERN]({ commit, state }, { model: pattern, form: form }) {
        classValidate(pattern, 'Pattern')

        await form.post(`/api/pattern/detach`)
    },

    async [action.ADD_PATTERN]({ commit }, { model: pattern, form: form }) {
        classValidate(pattern, 'Pattern')

        const { data } = await form.post(`/api/pattern`)

        commit(action.ADD_PATTERN, new Pattern(data))
    },
}

export const getters = {
    [getter.PATTERNS]: (state) => state.patterns,
}

export default {
    state,
    mutations,
    actions,
    getters,
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/patterns.js